export default {
  zh: {
    earthquake: {
      title: '地震预测数据管理',
      btn: {
        backHome: '回到首页',
        add: '添加预测',
        map: '地震预测地图',
        plate: '区域管理',
        view: '查看',
        edit: '编辑',
        publish: '发布',
        delete: '删除',
        search: '查询',
        reset: '重置',
        cancel: '取消',
        confirm: '确定',
        confirmPublish: '确定发布',
        close: '关 闭',
        export: '一键导出',
        prev: '上一条',
        next: '下一条',
      },
      search: {
        predDate: '预测发布时间',
        startTime: '开始时间',
        endTime: '结束时间',
        to: '至',
        hasResult: '是否发布',
        published: '已发布',
        unpublished: '未发布',
        plName: '区域名称',
        selectPlate: '请选择区域'
      },
      table: {
        predNum: '预测序号',
        predLat: '预测纬度(°)',
        predLng: '预测经度(°)',
        plName: '区域名称',
        predMag: '预测震级(M)',
        predOpname: '预测发布人',
        predDate: '预测发布时间',
        predShowremark: '预测说明在地图上',
        predRemark: '预测说明',
        detail: '详情',
        actHappen: '是否发生',
        happened: '已发生',
        notHappened: '未发生',
        actStartdate: '发生时间',
        actLat: '实际纬度(°)',
        actLng: '实际经度(°)',
        actMag: '实际震级(M)',
        dayOffset: '间隔天数(天)',
        distance: '距离(km)',
        actOpname: '结果发布人',
        actDate: '结果发布时间',
        actDatasource: '数据来源',
        operation: '操作',
        show: '显示',
        hide: '隐藏',
        informationMode: '信息方式',
        predInfosourceMacro: '宏观',
        predInfosourceMicro: '微观',
        actFocalDepth: '震源深度',
        actFocalDepthKm: '震源深度(km)',
        actRemark: '发布说明',
        actIssued: '是否已发布',
        issued: '已发布',
        notIssued: '未发布',
      },
      view: {
        predNum: '预测序号',
        predCoord: '预测坐标',
        coordLabel: '经纬度(°)',
        predDate: '预测发布时间',
        predMag: '预测震级(M)',
        plName: '区域',
        predOpname: '预测发布人',
        predShowremark: '预测说明在地图上',
        predRemark: '预测说明',
        actHappen: '是否发生',
        actCoord: '实际坐标',
        actStartdate: '发生时间',
        actMag: '实际震级(M)',
        actDate: '结果发布时间',
        dayOffset: '间隔天数',
        distance: '相隔距离',
        actOpname: '结果发布人',
        actDatasource: '数据来源',
        informationMode: '信息方式',
        predInfosourceMacro: '宏观',
        predInfosourceMicro: '微观',
        actFocalDepth: '震源深度',
        actFocalDepthKm: '震源深度 (km)',
        actRemark: '发布说明',
        actIssued: '是否已发布',
      },
      form: {
        addTitle: '添加预测',
        editTitle: '编辑预测数据',
        publishTitle: '发布结果',
        viewTitle: '记录详情',
        predSection: '预测数据',
        actSection: '实际数据',
        resultSection: '自动计算结果',
        predNumText: '预测序号',
        predOpname: '发布人',
        predDate: '发布时间',
        longitude: '经度(°)',
        latitude: '纬度(°)',
        magnitude: '震级(M)',
        magnitudeTip: '±0.5级',
        plateArea: '区域',
        regionCode: '区域代码',
        regionNum: '区域编号',
        predRemark: '预测说明',
        predShowremark: '预测说明在地图上',
        actHappen: '是否发生',
        actOpname: '发布人',
        actLongitude: '经度(°)',
        actLatitude: '纬度(°)',
        actMagnitude: '震级(M)',
        actStartdate: '发生时间',
        actDate: '结果发布时间',
        actDatasource: '数据来源',
        distance: '距离',
        interval: '间隔天数',
        km: 'km',
        day: '天',
        selectPlaceholder: '请选择',
        inputPlaceholder: '请输入',
        selectDate: '选择日期',
        selectDateTime: '选择日期时间',
        pickOnMap: '在地图上选择位置',
        mapPickTitle: '选择位置',
        mapPickTip: '请在地图上点击选择位置',
        yes: '显示',
        no: '隐藏',
        informationMode: '信息方式',
        predInfosourceMacro: '宏观',
        predInfosourceMicro: '微观',
        actFocalDepth: '震源深度',
        actFocalDepthKm: '震源深度 (km)',
        actRemark: '发布说明',
        predictSuccess: '预测成功',
        predictFail: '预测失败',
      },
      msg: {
        addSuccess: '新增成功',
        addFail: '新增失败',
        editSuccess: '修改成功',
        editFail: '修改失败',
        publishSuccess: '发布成功',
        publishFail: '发布失败',
        deleteSuccess: '删除成功',
        deleteFail: '删除失败',
        loadFail: '加载数据失败，请稍后重试',
        deleteConfirm: '确定删除该条记录吗？',
        tip: '提示',
        confirmDelete: '确定',
        cancel: '取消',
        exportEmpty: '当前数据为空，无需导出',
        exportSuccess: '导出成功',
        exportFail: '导出失败，请重试',
        cannotFutureTime: '不能选择未来时间'
      },
      validate: {
        predOpname: '请输入预测发布人',
        predDate: '请选择预测发布时间',
        predMagnitude: '请输入预测震级',
        predLatitude: '请输入预测纬度',
        predLongitude: '请输入预测经度',
        plId: '请选择区域',
        predRegioncode: '请选择区域代码',
        predRegionnum: '请选择区域编号',
        predShowremark: '请选择是否在地图上显示预测说明',
        actHappen: '请选择是否发生',
        actOpname: '请输入结果发布人',
        actDate: '请选择结果发布时间',
        predInfosourceMacro: '请选择宏观',
        predInfosourceMicro: '请选择微观',
      }
    }
  },
  en: {
    earthquake: {
      title: 'Earthquake Prediction Data Management',
      btn: {
        backHome: 'Back to Home',
        add: 'Add Prediction',
        map: 'Prediction Map',
        plate: 'Region Management',
        view: 'View',
        edit: 'Edit',
        publish: 'Publish',
        delete: 'Delete',
        search: 'Search',
        reset: 'Reset',
        cancel: 'Cancel',
        confirm: 'Confirm',
        confirmPublish: 'Confirm Publish',
        close: 'Close',
        export: 'Export All',
        prev: 'Previous',
        next: 'Next',
      },
      search: {
        predDate: 'Publish Time',
        startTime: 'Start Time',
        endTime: 'End Time',
        to: 'to',
        hasResult: 'Published',
        published: 'Published',
        unpublished: 'Unpublished',
        plName: 'Region Name',
        selectPlate: 'Select region'
      },
      table: {
        predNum: 'Pred. No.',
        predLat: 'Pred. Lat (°)',
        predLng: 'Pred. Lng (°)',
        plName: 'Region Name',
        predMag: 'Pred. Mag (M)',
        predOpname: 'Pred. Publisher',
        predDate: 'Publish Time',
        predShowremark: 'Show Note on Map',
        predRemark: 'Note',
        detail: 'Detail',
        actHappen: 'Occurred',
        happened: 'Occurred',
        notHappened: 'Not Occurred',
        actStartdate: 'Occurred Time',
        actLat: 'Actual Lat (°)',
        actLng: 'Actual Lng (°)',
        actMag: 'Actual Mag (M)',
        dayOffset: 'Interval (days)',
        distance: 'Distance (km)',
        actOpname: 'Result Publisher',
        actDate: 'Result Publish Time',
        actDatasource: 'Data Source',
        operation: 'Actions',
        show: 'Show',
        hide: 'Hide',
        informationMode: 'Information Mode',
        predInfosourceMacro: 'Macro',
        predInfosourceMicro: 'Micro',
        actFocalDepth: 'Focal Depth',
        actFocalDepthKm: 'Focal Depth (km)',
        actRemark: 'Publish Note',
        actIssued: 'Published',
        issued: 'Published',
        notIssued: 'Unpublished',
      },
      view: {
        predNum: 'Pred. No.',
        predCoord: 'Prediction Coord.',
        coordLabel: 'Lat/Lng (°)',
        predDate: 'Publish Time',
        predMag: 'Predicted Mag (M)',
        plName: 'Region',
        predOpname: 'Pred. Publisher',
        predShowremark: 'Show Note on Map',
        predRemark: 'Note',
        actHappen: 'Occurred',
        actCoord: 'Actual Coord.',
        actStartdate: 'Occurred Time',
        actMag: 'Actual Mag (M)',
        actDate: 'Result Publish Time',
        dayOffset: 'Interval',
        distance: 'Distance',
        actOpname: 'Result Publisher',
        actDatasource: 'Data Source',
        informationMode: 'Information Mode',
        predInfosourceMacro: 'Macro',
        predInfosourceMicro: 'Micro',
        actFocalDepth: 'Focal Depth',
        actFocalDepthKm: 'Focal Depth (km)',
        actRemark: 'Publish Note',
        actIssued: 'Published',
      },
      form: {
        addTitle: 'Add Prediction',
        editTitle: 'Edit Prediction Data',
        publishTitle: 'Publish Result',
        viewTitle: 'Record Details',
        predSection: 'Prediction Data',
        actSection: 'Actual Data',
        resultSection: 'Auto Calculated',
        predNumText: 'Pred. No.',
        predOpname: 'Pred. Publisher',
        predDate: 'Publish Time',
        longitude: 'Longitude (°)',
        latitude: 'Latitude (°)',
        magnitude: 'Magnitude (M)',
        magnitudeTip: '±0.5 M',
        plateArea: 'Region',
        regionCode: 'Region Code',
        regionNum: 'Region No.',
        predRemark: 'Prediction Note',
        predShowremark: 'Show Note on Map',
        actHappen: 'Occurred',
        actOpname: 'Result Publisher',
        actLongitude: 'Longitude (°)',
        actLatitude: 'Latitude (°)',
        actMagnitude: 'Magnitude (M)',
        actStartdate: 'Occurred Time',
        actDate: 'Result Publish Time',
        actDatasource: 'Data Source',
        distance: 'Distance',
        interval: 'Interval',
        km: 'km',
        day: 'day(s)',
        selectPlaceholder: 'Please select',
        inputPlaceholder: 'Please enter',
        selectDate: 'Select date',
        selectDateTime: 'Select date & time',
        pickOnMap: 'Pick on map',
        mapPickTitle: 'Pick Location',
        mapPickTip: 'Click on the map to pick a location',
        yes: 'Show',
        no: 'Hide',
        informationMode: 'Information Mode',
        predInfosourceMacro: 'Macro',
        predInfosourceMicro: 'Micro',
        actFocalDepth: 'Focal Depth',
        actFocalDepthKm: 'Focal Depth (km)',
        actRemark: 'Publish Note',
        predictSuccess: 'Prediction Successful',
        predictFail: 'Prediction Failed',
      },
      msg: {
        addSuccess: 'Added successfully',
        addFail: 'Failed to add',
        editSuccess: 'Updated successfully',
        editFail: 'Failed to update',
        publishSuccess: 'Published successfully',
        publishFail: 'Failed to publish',
        deleteSuccess: 'Deleted successfully',
        deleteFail: 'Failed to delete',
        loadFail: 'Failed to load data, please try again later',
        deleteConfirm: 'Are you sure to delete this record?',
        tip: 'Tip',
        confirmDelete: 'Delete',
        cancel: 'Cancel',
        exportEmpty: 'The form is empty, nothing to export',
        exportSuccess: 'Exported successfully',
        exportFail: 'Export failed, please try again',
        cannotFutureTime: 'Future time is not allowed'
      },
      validate: {
        predOpname: 'Please enter publisher',
        predDate: 'Please select publish time',
        predMagnitude: 'Please enter magnitude',
        predLatitude: 'Please enter latitude',
        predLongitude: 'Please enter longitude',
        plId: 'Please select region',
        predRegioncode: 'Please select region code',
        predRegionnum: 'Please select region number',
        predShowremark: 'Please choose whether to show note on map',
        actHappen: 'Please select whether it occurred',
        actOpname: 'Please enter result publisher',
        actDate: 'Please select result publish time',
        predInfosourceMacro: 'Please select macro info source',
        predInfosourceMicro: 'Please select micro info source'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/modules/earthquake.js